import { observer } from "mobx-react-lite"

import { Vertical } from "@/components/Flex.ts"
import { Heading2 } from "@/components/Heading/Heading.tsx"
import { ProjectSecretsEditor } from "@/components/ProjectSecretsEditor/ProjectSecretsEditor.tsx"
import { Spinner } from "@/components/Spinner/Spinner.tsx"
import { ellipsize } from "@/styles/textStyles.ts"

import type { ProjectSecretsViewModel } from "@/routes/projects/secrets/ProjectSecretsViewModel.ts"
import type { IObservableValue } from "mobx"


export const ProjectSecretsTab = observer((props: {
  model: ProjectSecretsViewModel
  canEditProject: IObservableValue<boolean>
}) => {
  const secretsModel = props.model

  return (
    <Vertical>
      <Heading2>Project Secrets</Heading2>
      {secretsModel.isLoading.get()
        ? <Spinner text={ellipsize("Loading")} />
        : (
          <ProjectSecretsEditor
            secrets={secretsModel.secrets.get()}
            onAddSecret={secretsModel.addSecret}
            onDeleteSecret={secretsModel.deleteSecret}
            onValueChange={secretsModel.updateSecretValue}
            canEditProject={props.canEditProject.get()}
          />
        )}
    </Vertical>
  )
})
